import { Box, Typography, useMediaQuery } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import NextIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";

const ArticleNavigator = ({ isNext, link, name }) => {
  const matches = useMediaQuery("only screen and (max-width:530px)");

  return (
    <Box
      sx={{
        ...(matches
          ? {
              width: "10rem",
              height: "3.5rem",
            }
          : { width: "15rem", height: "4rem" }),
        display: "flex",
        flexDirection: isNext ? "row" : "row-reverse",
        justifyContent: "space-around",
        alignItems: "center",
        background: `linear-gradient(${
          isNext ? "to right" : "to left"
        }, hsla(250 23% 15% / 0.2), hsla(250 30% 15% / 0.8))`,
        backgroundClip: "content-box",
        borderRadius: "10px",
        border: "1px solid hsl(250 23% 40%)",
        transition: "0.1s ease-in-out",

        "&:hover": {
          cursor: "pointer",
          transform: "scale(1.025)",
          background: `linear-gradient(${
            isNext ? "to right" : "to left"
          }, hsla(250 30% 15% / 0.2), hsla(250 37% 15% / 0.8))`,
        },

        "&:active": {
          transform: "scale(1)",
        },
        color: "white",
        textDecoration: "none",
      }}
      component={Link}
      to={link}
    >
      <Box
        sx={{
          flexGrow: 0.7,
          maxWidth: "70%",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        {!matches && (
          <Typography sx={{ fontSize: "1.15rem" }}>
            {`${isNext ? "Next" : "Previous"} Article`}
          </Typography>
        )}
        <Typography color={matches ? "text.primary" : "text.secondary"}>
          {name}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 0.3,
          minWidth: "40px",
          minHeight: "40px",
          maxWidth: "40px",
          maxHeight: "40px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid hsl(250 100% 80%)",
          margin: isNext ? "0 10px 0 0" : "0 0 0 10px",
        }}
      >
        {isNext ? <NextIcon /> : <BackIcon />}
      </Box>
    </Box>
  );
};

export default ArticleNavigator;
